/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'power-on-off': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M26.322 4.062c5.132 4.29 7.01 11.296 4.704 17.54C28.719 27.847 22.716 32 16 32 9.283 32 3.281 27.847.974 21.602c-2.307-6.244-.428-13.25 4.704-17.54a1.158 1.158 0 011.62.135 1.13 1.13 0 01-.137 1.604c-4.394 3.673-6.003 9.672-4.027 15.02 1.975 5.347 7.114 8.903 12.866 8.903s10.89-3.556 12.866-8.903c1.976-5.348.367-11.347-4.027-15.02a1.13 1.13 0 01-.137-1.604c.41-.48 1.135-.54 1.62-.135zM16.005 0a1.15 1.15 0 011.136.933l.018.205v15.174c0 .628-.516 1.138-1.154 1.138a1.15 1.15 0 01-1.136-.934l-.019-.204V1.138C14.85.51 15.367 0 16.005 0z"/>'
  }
})
